import { Avatar, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Practitioner } from '../types';
import { PractitionerDialog } from './PractitionerDialog';
import { useGetSessionQuery } from '../services/api';

export function PractitionerProfileCard({
  guid
}: {
  guid?: string;
}) {
  const { data: session } = useGetSessionQuery(guid);
  const [selectedPractitioner, setSelectedPractitioner] = useState<Practitioner | undefined>()

  if (!session?.practitioner)
    return null;

  return (
    <Card
      style={{}}
    >
      <CardContent>
        <Typography
          borderBottom='1px solid'
          fontWeight={500}
          gutterBottom
        >Meet the Practitioner</Typography>
        <Grid
          container
        >
          <Grid
            item
            xs={3}
          >
            <Avatar alt={session?.practitioner?.fullName} />
          </Grid>
          <Grid
            item
            xs={9}
          >
            <Typography
              fontWeight={500}
            >{session?.practitioner?.fullName}</Typography>
            <Typography
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '5',
                WebkitBoxOrient: 'vertical',
              }}
            >{session?.practitioner?.bio}</Typography>
            <Button
              component='a'
              onClick={() => setSelectedPractitioner(session?.practitioner)}
              style={{
                fontSize: 12
              }}
            >View Profile</Button>
            <PractitionerDialog
              omitSession={guid}
              onClose={() => setSelectedPractitioner(undefined)}
              practitioner={selectedPractitioner}
              showSessions={true}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
